import React, { useState, useRef, useEffect } from "react";
import MenuItemFresha from "./MenuItemFresha";
// import BusinessSidebar from "./menuItem/BusinessSidebar";
import useWindowResize from "../../hooks/useWindowResize";
import { Search } from "lucide-react";
import CartBottomBar from "./CartBottomBar";
import FavouriteBar from "./FavouriteBar";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const MenuListWithSidebar = ({
  menuCategories,
  menuItems,
  selectedCategoryId,
  setSelectedCategoryId,
  setModalItem,
  //   businessInfo,
  expandedCategory,
  selectedValues = [],
}) => {
  const [selectedId, setSelectedId] = useState([]);
  const [totalTime, setTotalTime] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const categoryRefs = useRef({});
  const categoryButtonRefs = useRef({});

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const groupedItems = menuCategories.reduce((acc, cat) => {
    acc[cat._id] =
      menuItems?.filter((item) => item.category?._id === cat._id) || [];
    return acc;
  }, {});

  const selectedCategoryFromRedux = useSelector(
    (state) => state.cart.selectedCategory?._id,
  );

  const selectedCategoryFromReduxName = useSelector(
    (state) => state.cart.selectedCategory?.name,
  );

  // console.log({ selectedCategoryFromReduxName });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const categoryId = entry.target.getAttribute("data-category-id");
            if (categoryId) {
              setSelectedCategoryId(categoryId);

              const button = categoryButtonRefs.current?.[categoryId];
              if (button) {
                button.scrollIntoView({
                  behavior: "smooth",
                  inline: "start",
                  block: "nearest",
                });
              }
            }
          }
        });
      },
      { threshold: 0.4 },
    );

    Object.keys(categoryRefs.current).forEach((id) => {
      if (categoryRefs.current[id]) {
        observer.observe(categoryRefs.current[id]);
      }
    });

    return () => observer.disconnect();
  }, [menuCategories]);

  useEffect(() => {
    if (!selectedCategoryFromRedux) return;

    const timeout = setTimeout(() => {
      const section = categoryRefs.current[selectedCategoryFromRedux];

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      const button = categoryButtonRefs.current[selectedCategoryFromRedux];

      if (button) {
        button.scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest",
        });
      }
    }, 150); // wait for render

    return () => clearTimeout(timeout);
  }, [selectedCategoryFromRedux, menuCategories]);

  let WIN_WIDTH = useWindowResize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }

  const highlightMatch = (text, keyword) => {
    if (!keyword) return text;
    const regex = new RegExp(`(${keyword})`, "gi");
    return text.split(regex).map((part, i) =>
      part.toLowerCase() === keyword.toLowerCase() ? (
        <mark key={i} className="bg-neonYellow text-navy">
          {part}
        </mark>
      ) : (
        <span key={i}>{part}</span>
      ),
    );
  };

  const favouriteItems = menuItems
    .filter(
      (item) => item.orderCount >= 5 || item.isStaffChoice || item.isNewItem,
    )
    .sort((a, b) => b.orderCount - a.orderCount)
    .slice(0, 15);

  return (
    <div className="max-w-6xl mx-auto p-0 flex flex-col gap-6  ">
      {/* Fixed top area */}
      <div className="sticky top-[80px]  bg-darkbg lg:pt-6 lg:pb-6 py-6 lg:top-[80px] z-50">
        <div className="flex items-start ">
          <button
            onClick={() => setIsSearchOpen(!isSearchOpen)}
            className="flex items-center justify-center min-w-[40px] h-[40px] rounded-full  text-neonYellow "
          >
            <Search size={18} />
          </button>
          <div className="flex items-center overflow-x-auto  space-x-3 mb-4 pb-2 scrollbar-thin border-b border-neonYellow">
            {menuCategories
              .filter((cat) =>
                (groupedItems[cat._id] || []).some((item) =>
                  item.title.toLowerCase().includes(searchTerm.toLowerCase()),
                ),
              )
              .map((cat) => (
                <button
                  key={cat._id}
                  ref={(el) => (categoryButtonRefs.current[cat._id] = el)}
                  onClick={() => {
                    const section = categoryRefs.current[cat._id];
                    if (section) section.scrollIntoView({ behavior: "smooth" });
                  }}
                  className={`whitespace-nowrap px-4 py-2 ml-2 rounded-full text-sm font-semibold  ${
                    selectedCategoryId === cat._id
                      ? "bg-navy text-neonYellow animate-neonFlicker border border-navy"
                      : "text-neonYellow"
                  }`}
                >
                  {cat.name}
                </button>
              ))}
          </div>
        </div>
        <div
          className={`transition-all duration-300 ease-in-out overflow-hidden px-4 ${
            isSearchOpen ? "max-h-20" : "max-h-0"
          }`}
        >
          <input
            type="text"
            placeholder="Search menu..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-3 pr-3 py-2 rounded-lg border border-textGray bg-darkbg text-text
        placeholder:text-textGray text-sm"
          />
        </div>
      </div>

      <div className="pt-4 pb-20 px-4 z-60">
        <FavouriteBar
          items={favouriteItems} // show first 8 as featured
          onSelect={(item) => setModalItem(item)}
        />
        {menuCategories.map((cat) => {
          const filteredItems = groupedItems[cat._id].filter((item) =>
            item.title.toLowerCase().includes(searchTerm.toLowerCase()),
          );
          if (filteredItems.length === 0) return null;

          return (
            <div
              key={cat._id}
              ref={(el) => (categoryRefs.current[cat._id] = el)}
              data-category-id={cat._id}
              className="mb-6"
            >
              <div className="flex justify-between my-3">
                <h3 className="text-xl font-bold text-text mb-3 uppercase">
                  {cat.name}
                </h3>
                <div className="w-[50%] sm:max-w-full max-w-[50%]">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full object-cover mx-auto sm:max-h-[70px] lg:max-h-[150px]"
                  />
                </div>
              </div>
              {filteredItems.map((item) => {
                const isSelected = selectedValues.some(
                  (v) => v._id === item._id,
                );

                return (
                  <div key={item._id} className="mb-2">
                    <MenuItemFresha
                      item={item}
                      highlightMatch={highlightMatch}
                      searchTerm={searchTerm}
                      isSelected={isSelected}
                      onClick={() => {
                        setModalItem(item);
                      }}
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MenuListWithSidebar;
